import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import * as laborWorkorderActions from '../labor-workorder/labor-workorder.actions';
import {
  catchError,
  map,
  mergeMap,
  switchMap,
  tap,
  throttleTime,
} from 'rxjs/operators';
import { from, Observable, of } from 'rxjs';
import {
  HideSpinner,
  ShowSpinner,
} from '../../../shared/spinner/spinner.action';
import { Action } from '@ngrx/store';
import * as ErrorActions from '../../error/error.actions';
import { ErrorType } from '../../error/model/error-type';
import { AlertMessageCommonService } from '../../../shared/alert-message-common/alert-message-common.service';
import { ServiceOrderService } from '../../backend/service-order/service-order.service';

type showSpinnerTypes = laborWorkorderActions.LaborWorkorderGetRequest;

const showSpinnerActions = [laborWorkorderActions.LABOR_WORKORDER_GET_REQUEST];

type hideSpinnerTypes = laborWorkorderActions.LaborWorkorderGetReceive;

const hideSpinnerActions = [laborWorkorderActions.LABOR_WORKORDER_GET_RECEIVE];

@Injectable()
export class LaborWorkorderEffects {
  constructor(
    private actions$: Actions,
    private serviceOrderService: ServiceOrderService,
    private alertMessageCommonService: AlertMessageCommonService
  ) {}

  @Effect()
  showSpinner: Observable<Action> = this.actions$.pipe(
    ofType<showSpinnerTypes>(...showSpinnerActions),
    map(() => new ShowSpinner())
  );

  @Effect()
  hideSpinner: Observable<Action> = this.actions$.pipe(
    ofType<hideSpinnerTypes>(...hideSpinnerActions),
    map(() => new HideSpinner())
  );

  @Effect()
  OnlaborWorkorderGetRequest$ = this.actions$.pipe(
    ofType<laborWorkorderActions.LaborWorkorderGetRequest>(
      laborWorkorderActions.LABOR_WORKORDER_GET_REQUEST
    ),
    map((action) => action.payload),
    throttleTime(2000),
    switchMap((payload) =>
      from(this.serviceOrderService.workOrderGetLabor(payload)).pipe(
        mergeMap((workorderList) => [
          new laborWorkorderActions.LaborWorkorderGetReceive({
            workorderList: workorderList,
            isScrolled: payload.isScrolled,
          }),
        ]),
        catchError((data) =>
          of(
            new ErrorActions.ErrorReceive({
              message: data.error.message,
              type: ErrorType.token,
              statusCode: data.status,
            })
          )
        )
      )
    )
  );
}
